angular
    .module('empower.memberBenefit')
    .controller('memberBenefitController', ['$scope', '$rootScope', '$http', 'jurisdictionEnum', 'memberBenefitService',
        function ($scope, $rootScope, $http, jurisdictionEnum, memberBenefitService) {
            $scope.pageName = $rootScope.IsACT ? 'Resources' : 'Member Benefits';
            $scope.pageBreadcrumbs = [{
                url: '/',
                title: 'Home'
            }, {
                url: null,
                title: $rootScope.IsACT ? 'Resources' : 'Member Benefits' 
            }];

            $scope.jurisdictionEnum = jurisdictionEnum;

            $scope.init = function () {
                $scope.jurisdiction = $rootScope.getSelectedJurisdiction();
                if ($rootScope.IsACT)
                    $scope.jurisdiction = 3
                $scope.nswSelected = $scope.jurisdiction === jurisdictionEnum.NSW;
                $scope.vicSelected = $scope.jurisdiction === jurisdictionEnum.VIC;
                $scope.actSelected = $scope.jurisdiction === jurisdictionEnum.ACT;
                $scope.firstColsResourcesVic = [];
                $scope.secondcolsResourcesVic = [];
                $scope.firstColsResourcesNSW = [];
                $scope.secondcolsResourcesNSW = [];
                $scope.firstColsResourcesACT = [];
                $scope.secondcolsResourcesACT = [];
                memberBenefitService.getResources().then(function (response) {
                    response.forEach(function (element) {
                        element.ext = element.FilePath.split('.').pop();
                        element.link = element.DisplayName + '.' + element.ext;
                        switch (element.ext) {
                            case 'doc':
                            case 'docx':
                                element.icon = "fa fa-file-word-o";
                                break;
                            case 'xls':
                            case 'xlsx':
                                element.icon = "fa fa-file-excel-o";
                                break;
                            case 'pdf':
                                element.icon = "fa fa-file-pdf-o";
                                break;
                            default:
                                element.icon = "fa fa-file-word-o";
                                break;
                        }
                        if (element.IsDirectLink) {
                            element.icon = "fa fa-external-link";
                        }
                    });
                    var resourceVic = response.filter(function (item) {
                        return item.BusinessUnit == 2;
                    });
                    var resourceNSW = response.filter(function (item) {
                        return item.BusinessUnit == 0;
                    });
                    var resourceACT = response.filter(function (item) {
                        return item.BusinessUnit == 3;
                    });

                    resourceNSW.sort(function (f1, f2) {
                        var name1 = f1.DisplayName.toUpperCase(); // ignore upper and lowercase
                        var name2 = f2.DisplayName.toUpperCase(); // ignore upper and lowercase
                        if (name1 < name2) {
                            return -1;
                        }
                        if (name1 > name2) {
                            return 1;
                        }
                        // names must be equal
                        return 0;

                    });
                    var idx = 0;
                    if (resourceNSW.length % 2 === 0)
                        idx = resourceNSW.length / 2;
                    else
                        idx = (resourceNSW.length / 2) + 1;

                    $scope.firstColsResourcesNSW = resourceNSW.slice(0, idx);
                    $scope.secondColsResourcesNSW = resourceNSW.slice(idx, resourceNSW.length);

                    resourceVic.sort(function (f1, f2) {
                        var name1 = f1.DisplayName.toUpperCase(); // ignore upper and lowercase
                        var name2 = f2.DisplayName.toUpperCase(); // ignore upper and lowercase
                        if (name1 < name2) {
                            return -1;
                        }
                        if (name1 > name2) {
                            return 1;
                        }
                        // names must be equal
                        return 0;

                    });
                    var idx = 0;
                    if (resourceVic.length % 2 === 0)
                        idx = resourceVic.length / 2;
                    else
                        idx = (resourceVic.length / 2) + 1;

                    $scope.firstColsResourcesVic = resourceVic.slice(0, idx);
                    $scope.secondColsResourcesVic = resourceVic.slice(idx, resourceVic.length);

                    resourceACT.sort(function (f1, f2) {
                        var name1 = f1.DisplayName.toUpperCase(); // ignore upper and lowercase
                        var name2 = f2.DisplayName.toUpperCase(); // ignore upper and lowercase
                        if (name1 < name2) {
                            return -1;
                        }
                        if (name1 > name2) {
                            return 1;
                        }
                        // names must be equal
                        return 0;

                    });
                    var idx = 0;
                    if (resourceACT.length % 2 === 0)
                        idx = resourceACT.length / 2;
                    else
                        idx = (resourceACT.length / 2) + 1;

                    $scope.firstColsResourcesACT = resourceACT.slice(0, idx);
                    $scope.secondColsResourcesACT = resourceACT.slice(idx, resourceACT.length);
                })

            }

            $scope.openAccordion = function (jurisdiction) {
                if (jurisdiction === jurisdictionEnum.NSW) {
                    $scope.nswSelected = !$scope.nswSelected;

                } else if (jurisdiction === jurisdictionEnum.VIC) {
                    $scope.vicSelected = !$scope.vicSelected;
                } else if (jurisdiction === jurisdictionEnum.ACT) {
                    $scope.actSelected = !$scope.actSelected
                }

            }

            $scope.download = function (filePath, displayName) {
                memberBenefitService.downloadResource(filePath, displayName);
            }
        }
    ]);